import React from 'react';
import PropTypes from 'prop-types';
import {routerShape, locationShape} from 'react-router/lib/PropTypes';

export const RouterContext = React.createContext();
export const LocationContext = React.createContext();

RouterProvider.propTypes = {
    router: routerShape.isRequired,
    location: locationShape.isRequired,
    children: PropTypes.node.isRequired,
};
export function RouterProvider({router, location, children}) {
    return (
        <RouterContext.Provider value={router}>
            <LocationContext.Provider value={location}>{children}</LocationContext.Provider>
        </RouterContext.Provider>
    );
}

export default function useRouter() {
    return React.useContext(RouterContext);
}

export function useLocation() {
    return React.useContext(LocationContext);
}
